/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PracticeBranchResponseDto
 */
export interface PracticeBranchResponseDto {
    /**
     * Branch ID (UUID)
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    id: string;
    /**
     * Practice ID (UUID)
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    practiceId: string;
    /**
     * Branch address
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    address: string;
    /**
     * Street name
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    street: string;
    /**
     * City name
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    city: string;
    /**
     * State name
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    state: string;
    /**
     * ZIP code
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    zip: string;
    /**
     * Branch email address
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    emailAddress: string;
    /**
     * Primary phone number
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    primaryPhoneNumber: string;
    /**
     * Fax number
     * @type {string}
     * @memberof PracticeBranchResponseDto
     */
    faxNumber?: string;
    /**
     * Number of staff assigned to this branch
     * @type {number}
     * @memberof PracticeBranchResponseDto
     */
    staffCount: number;
    /**
     * Created timestamp
     * @type {Date}
     * @memberof PracticeBranchResponseDto
     */
    createdAt: Date;
    /**
     * Updated timestamp
     * @type {Date}
     * @memberof PracticeBranchResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the PracticeBranchResponseDto interface.
 */
export function instanceOfPracticeBranchResponseDto(value: object): value is PracticeBranchResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('practiceId' in value) || value['practiceId'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('emailAddress' in value) || value['emailAddress'] === undefined) return false;
    if (!('primaryPhoneNumber' in value) || value['primaryPhoneNumber'] === undefined) return false;
    if (!('staffCount' in value) || value['staffCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PracticeBranchResponseDtoFromJSON(json: any): PracticeBranchResponseDto {
    return PracticeBranchResponseDtoFromJSONTyped(json, false);
}

export function PracticeBranchResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeBranchResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'practiceId': json['practiceId'],
        'address': json['address'],
        'street': json['street'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'emailAddress': json['emailAddress'],
        'primaryPhoneNumber': json['primaryPhoneNumber'],
        'faxNumber': json['faxNumber'] == null ? undefined : json['faxNumber'],
        'staffCount': json['staffCount'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function PracticeBranchResponseDtoToJSON(json: any): PracticeBranchResponseDto {
    return PracticeBranchResponseDtoToJSONTyped(json, false);
}

export function PracticeBranchResponseDtoToJSONTyped(value?: PracticeBranchResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'practiceId': value['practiceId'],
        'address': value['address'],
        'street': value['street'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'emailAddress': value['emailAddress'],
        'primaryPhoneNumber': value['primaryPhoneNumber'],
        'faxNumber': value['faxNumber'],
        'staffCount': value['staffCount'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

